module.exports = __webpack_public_path__ + "static/media/logout.6889ec25.svg";